export const testParcel = {
    data: {
        parcel: {
            mysteryParcelId: 'test',
            eventStartTime: 1596664557837,
            eventEndTime: 1602322702,
            status: 'ACTIVE',
            registrationStatus: 'IN_PROGRESS',
            joined: true,
            prizes: [{
                displayName: 'Test final prize',
                awarded: 0,
                remaining: 1
            }, {
                displayName: 'Test free spins',
                awarded: 5,
                remaining: 10,
                finalPrize: true
            }, {
                displayName: 'Test bonus',
                awarded: 5,
                remaining: 6
            },
                {
                    displayName: 'Test bonus',
                    awarded: 5,
                    remaining: 6
                },
                {
                    displayName: 'Test bonus',
                    awarded: 5,
                    remaining: 6
                }
            ],
            prizesWon: [{
                prizeDisplayName: 'Test free spins',
                awarded: 2
            },
                {
                    prizeDisplayName: 'Test free spins2',
                    awarded: 2,
                    finalPrize: true
                }
            ],
            lastWinners: [{
                nickname: 'Test user 1',
                prizeDisplayName: 'Test bonus',
                timeAwarded: 1596665157837
            }, {
                nickname: 'Test user 2',
                prizeDisplayName: 'Test free spins',
                timeAwarded: 1596665157837,
                finalPrize: true,
                isCurrentUser: true
            }, {
                nickname: 'Test user 3',
                prizeDisplayName: 'Test bonus',
                timeAwarded: 1596665157837
            },
                {
                    nickname: 'Test user 4',
                    prizeDisplayName: 'Test bonus',
                    timeAwarded: 1596665157837
                },
                {
                    nickname: 'Test user 5',
                    prizeDisplayName: 'Test bonus',
                    timeAwarded: 1596665157837
                }
            ],
            displayName: 'Mystery Parcel',
            bannerUrl: '',
            termsAndConditionsUrl: 'http://playtechone.com',
            rules: '<h1>Terms and conditions</h1>\n' +
                '<p>\n' +
                'After school, Kamal took the girls to the old house. It was very old and very dirty too. There was rubbish everywhere. The windows were broken and the walls were damp. It was scary. Amy didn’t like it. There were paintings of zombies and skeletons on the walls. “We’re going to take photos for the school art competition,” said Kamal. Amy didn’t like it but she didn’t say anything. “Where’s Grant?” asked Tara. “Er, he’s buying more paint.” Kamal looked away quickly. Tara thought he looked suspicious. “It’s getting dark, can we go now?” said Amy. She didn’t like zombies.\n' +
                '</p>\n' +
                '<h2>Games</h2>\n' +
                '<p>\n' +
                'Then, they heard a loud noise coming from a cupboard in the corner of the room. “What’s that?” Amy was frightened. “I didn’t hear anything,” said Kamal. Something was making strange noises. There was something inside the cupboard. “Oh no! What is it?” Amy was very frightened now. “What do you mean? There’s nothing there!” Kamal was trying not to smile. Suddenly the door opened with a bang and a zombie appeared, shouting and moving its arms. Amy screamed and covered her eyes. “Oh very funny, Grant!” said Tara looking bored. Kamal and Grant started laughing. “Ha ha, you were frightened!” said Grant. "Do you like my zombie costume?” Amy took Tara’s arm. “I can’t breathe,” she said. Kamal looked worried now. “Is she OK? It was only a joke.” “No she’s not OK, you idiot. She’s having an asthma attack and she forgot her inhaler.” Tara took out her phone. “I’m calling her dad.”\n' +
                '</p>\n' +
                '<h2>Mystery parcel points</h2>\n' +
                '<p>\n' +
                'Next evening was Halloween. The girls were at the school disco. “Are you better now?” asked Tara. “I’m fine,” said Amy. “I think it was the smell of paint that started the attack.” Tara looked around. “So, where are the zombies?” “I don’t know, I don’t want to see Kamal again,” said Amy. “Come on, let’s dance!”\n' +
                'Amy and Tara were dancing when Grant arrived, looking worried. “Hi, someone stole my phone. Have you seen Kamal? He said he was coming here at eight o’clock. Can you phone him?” “Go away, idiot!” Tara didn’t stop dancing. Grant looked upset. “Tell him I’m looking for him,” he called as he left the disco. Tara really didn’t like Grant.\n' +
                '</p>\n' +
                '<h2>Time limit</h2>\n' +
                '<p>\n' +
                '“I’m at the house. I can’t move. Please call an ambulance. My battery is running out.”\n' +
                'The girls didn’t stop dancing. Lots of their friends saw Kamal’s message too, but Tara told everyone it was just a joke. They all ignored it.\n' +
                'The next morning, Amy’s mum and dad were listening to the radio. “Is Amy up yet?” Dad asked. “No, she’s tired,” said mum, turning the volume up on the radio.\n' +
                '“This morning, police are investigating the death of a sixteen-year-old boy. He died last night in a disused house on Moortown Road...”\n' +
                '</p>\n',
            eligibilityRules: [{
                eligibilityType: 'STAKING',
                eligibilityValue: 5,
                accountedFrom: 'PLAYER_OPT_IN',
                eligbilityFulfilled: false
            }
            ],
            participatingGames: ['hlf', 'hlf', 'hlf', 'hlf', 'hlf', 'hlf', 'hlf', 'hlf', 'hlf', 'hlf', 'hlf', 'hlf', 'hlf', 'hlf'],
            customAttributes: []
        }
    },
    ID: 73011,
    description: 'Mystery Parcel Discovery Page subscription',
    time: 261
};
